import { createSlice } from "@reduxjs/toolkit";
import { fetchUserDetails, fetchLatestPermissions } from './thunk';
import { LoginState } from "./types";

// export const initialState = {
//   user: {},
//   error: "",
//   loading: false,
//   isUserLogout: false,
//   errorMsg: false,
// };
export const initialState: LoginState = {
  user: null,       // not {} — this makes TS allow optional checks
  error: null,
  loading: false,
  isUserLogout: false,
  errorMsg:false, 
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    apiError(state, action) {
      // state.error = action.payload.data;
      state.error = action.payload;
      state.loading = true;
      state.isUserLogout = false;
      state.errorMsg = true;
    },
    loginSuccess(state, action) {
      console.log("login success ");
      state.user = action.payload;
      state.loading = false;
      state.errorMsg = false;
      // console.log(
      //   `state: ${JSON.stringify(state)} , action: ${JSON.stringify(action)}`
      // );
      // console.log("state.user", state.user);
    },
    logoutUserSuccess(state, action) {
      state.isUserLogout = true;
    },
    reset_login_flag(state) {

      state.error = "";
      state.loading = false;
      state.errorMsg = false;
    },
  },
  extraReducers: (builder) => {
  builder
    .addCase(fetchUserDetails.fulfilled, (state, action) => {
      state.user = action.payload;
    })
    .addCase(fetchLatestPermissions.fulfilled, (state, action) => {
      if (state.user) {
        state.user.permissions = action.payload; 
      }
    });
  },
});


export const { apiError, loginSuccess, logoutUserSuccess, reset_login_flag } =
  loginSlice.actions;

export default loginSlice.reducer;
